(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jp-collab-carousel"] && !Shopify.designMode) return;
  try {
    
  class JpCollabCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.viewport = this.querySelector('[data-carousel-viewport]');
      if (!this.viewport) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.firstSlide = this.querySelector('[data-carousel-slide]');
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      this.pause = this.querySelector('[data-carousel-pause]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.interacting = false;
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.pause?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.viewport.addEventListener('pointerdown', () => { this.interacting = true; this.schedule(); }, options);
      const release = () => { if (this.interacting) { this.interacting = false; this.schedule(); } };
      document.addEventListener('pointerup', release, options);
      document.addEventListener('pointercancel', release, options);
      this.viewport.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      this.viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.scrollTo(event.key === 'Home' ? 0 : this.maximum(), true);
          this.schedule();
        }
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.resizeObserver = new ResizeObserver(() => { this.updateControls(); this.schedule(); });
      this.resizeObserver.observe(this.viewport);
      this.updateControls();
      this.schedule();
    }
    maximum() {
      return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
    }
    scrollTo(left, jump = false) {
      this.viewport.scrollTo({ left, behavior: jump || this.motion.matches ? 'instant' : 'smooth' });
    }
    move(direction) {
      const maximum = this.maximum();
      if (!maximum || !this.firstSlide) return;
      const position = this.viewport.scrollLeft;
      const step = this.firstSlide.getBoundingClientRect().width;
      let target = Math.max(0, Math.min(maximum, position + direction * step));
      let wrap = false;
      if (this.dataset.loop === 'true') {
        if (direction > 0 && position >= maximum - 1) { target = 0; wrap = true; }
        if (direction < 0 && position <= 1) { target = maximum; wrap = true; }
      }
      this.scrollTo(target, wrap);
      this.schedule();
    }
    updateControls() {
      const maximum = this.maximum();
      const loop = this.dataset.loop === 'true';
      if (this.previous) this.previous.disabled = maximum <= 1 || (!loop && this.viewport.scrollLeft <= 1);
      if (this.next) this.next.disabled = maximum <= 1 || (!loop && this.viewport.scrollLeft >= maximum - 1);
    }
    schedule() {
      clearTimeout(this.timer);
      const reduced = this.motion.matches;
      if (this.pause) {
        this.pause.disabled = reduced || this.maximum() <= 1;
        this.pause.setAttribute('aria-label', this.paused || reduced ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.pause.firstElementChild.textContent = this.paused || reduced ? '▶' : 'Ⅱ';
      }
      if (this.dataset.autoplay !== 'true' || this.maximum() <= 1 || this.paused || reduced || this.hovered || this.focused || this.interacting || document.hidden) return;
      if (this.dataset.loop !== 'true' && this.viewport.scrollLeft >= this.maximum() - 1) return;
      this.timer = setTimeout(() => this.move(1), 3500);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  }
  if (!customElements.get('jp-collab-carousel')) customElements.define('jp-collab-carousel', JpCollabCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-collab-film"] && !Shopify.designMode) return;
  try {
    
  class JpCollabFilm extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.video.pause();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
      }, options);
      if (this.dataset.autoplay === 'true' && !this.motion.matches && !document.hidden) {
        this.video.play().catch(() => {});
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.video?.pause();
      this.controller = null;
    }
  }
  if (!customElements.get('jp-collab-film')) customElements.define('jp-collab-film', JpCollabFilm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-family-collection-links"] && !Shopify.designMode) return;
  try {
    
  const initializeFamilyPrefetch = () => {
    if (Shopify.designMode) return;
    const nav = document.querySelector('[data-family-navigation]');
    if (!nav) return;
    const links = [...nav.querySelectorAll('.jp-family-collection-links__text-link')];
    const urls = [...new Set(links.map((link) => new URL(link.href)).filter((url) => url.origin === window.location.origin && url.pathname !== window.location.pathname).map((url) => url.href))];
    const warm = () => {
      if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
      if (HTMLScriptElement.supports?.('speculationrules')) {
        const rules = document.createElement('script');
        rules.type = 'speculationrules';
        rules.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls, eagerness: 'immediate' }] });
        document.head.append(rules);
      } else {
        for (const url of urls) {
          const hint = document.createElement('link');
          hint.rel = 'prefetch';
          hint.href = url;
          hint.as = 'document';
          document.head.append(hint);
        }
      }
    };
    if (document.readyState === 'complete') (window.requestIdleCallback || setTimeout)(warm);
    else window.addEventListener('load', () => (window.requestIdleCallback || setTimeout)(warm), { once: true });
    for (const link of links) {
      link.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
        link.classList.add('is-pending');
        nav.querySelector('[data-family-status]').textContent = '商品一覧を読み込んでいます';
        if (Shopify.theme.role === 'development') {
          try { sessionStorage.setItem('family-navigation-start', JSON.stringify({ url: link.href, started: Date.now() })); } catch {}
        }
      });
    }
    window.addEventListener('pageshow', () => {
      links.forEach((link) => link.classList.remove('is-pending'));
      nav.querySelector('[data-family-status]').textContent = '';
    });
    if (Shopify.theme.role === 'development') {
      requestAnimationFrame(() => {
        const entry = performance.getEntriesByType('navigation')[0];
        nav.dataset.navigationDelivery = entry?.deliveryType || 'network';
        nav.dataset.navigationResponseMs = String(Math.round(entry?.responseStart || 0));
        try {
          const previous = JSON.parse(sessionStorage.getItem('family-navigation-start') || 'null');
          if (previous?.url === window.location.href) nav.dataset.navigationDurationMs = String(Date.now() - previous.started);
          sessionStorage.removeItem('family-navigation-start');
        } catch {}
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeFamilyPrefetch, { once: true });
  else initializeFamilyPrefetch();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-footer-gallery"] && !Shopify.designMode) return;
  try {
    
  class JPFooterGallery extends HTMLElement {
    connectedCallback() {
      this.brandObserver?.disconnect();
      const feed = this.querySelector('.jp-footer-gallery__feed');
      if (!feed) return;
      const removeBrand = () => feed.querySelectorAll('a.snptwdgt__ftr-tgln12').forEach(brand => brand.remove());
      this.brandObserver = new MutationObserver(removeBrand);
      this.brandObserver.observe(feed, { childList: true, subtree: true });
      removeBrand();
    }
    disconnectedCallback() {
      this.brandObserver?.disconnect();
    }
  }
  if (!customElements.get('jp-footer-gallery')) customElements.define('jp-footer-gallery', JPFooterGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-home-slideshow"]) return;
  try {
    
  class JpHomeSlideshow extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-home-slide]')];
      this.bars = [...this.querySelectorAll('[data-home-index]')];
      this.pauseButton = this.querySelector('[data-home-pause]');
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-home-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-home-previous]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.bars.forEach((bar) => bar.addEventListener('click', () => this.show(Number(bar.dataset.homeIndex)), options));
      this.pauseButton?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('pointerenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1)); }
      }, options);
      this.addEventListener('pointerdown', (event) => { if (event.button === 0) this.startX = event.clientX; this.swiped = false; }, options);
      this.addEventListener('pointercancel', () => { this.startX = undefined; }, options);
      this.addEventListener('pointerup', (event) => {
        const distance = event.clientX - this.startX;
        if (Number.isFinite(distance) && Math.abs(distance) > 50) { this.swiped = true; this.show(this.index + (distance < 0 ? 1 : -1)); }
        this.startX = undefined;
      }, options);
      this.addEventListener('click', (event) => { if (this.swiped) { event.preventDefault(); this.swiped = false; } }, { ...options, capture: true });
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.show(0);
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.hidden = false;
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (active) slide.setAttribute('data-active', '');
        else slide.removeAttribute('data-active');
      });
      this.bars.forEach((bar, i) => { if (i === this.index) bar.setAttribute('aria-current', 'true'); else bar.removeAttribute('aria-current'); });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.motion.matches;
      if (this.pauseButton) {
        this.pauseButton.disabled = this.motion.matches;
        this.pauseButton.setAttribute('aria-label', stopped ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
        this.pauseButton.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
      }
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || stopped || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Math.max(1000, Number(this.dataset.speed) || 5000));
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  }
  if (!customElements.get('jp-home-slideshow')) customElements.define('jp-home-slideshow', JpHomeSlideshow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-imersian-inhome"] && !Shopify.designMode) return;
  try {
    
  class JpImersianInhome extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.imersian-variant-sku');
      this.buttons = [...this.querySelectorAll('button')];
      this.controller = new AbortController();
      this.observer = new MutationObserver(() => this.syncVisibility());
      for (const button of this.buttons) this.observer.observe(button, { attributes: true, attributeFilter: ['style'] });
      document.addEventListener('variant:update', (event) => this.updateVariant(event), { signal: this.controller.signal });
      this.syncVisibility();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    syncVisibility() {
      if (window.Shopify?.designMode || this.dataset.autoHide !== 'true') return;
      this.hidden = this.buttons.every(button => button.style.display === 'none');
    }
    updateVariant(event) {
      if (!this.dataset.productId || String(event.detail?.data?.productId) !== this.dataset.productId) return;
      this.input.value = event.detail.resource?.id || '';
      this.input.setAttribute('value', this.input.value);
      for (const button of this.buttons) button.style.display = 'none';
      this.syncVisibility();
      if (!this.input.value) return;
      window.jpImersianReady?.then(client => {
        if (this.isConnected && this.input.value) return client.handleVariantChange?.();
      }).catch(() => {});
    }
  }
  if (!customElements.get('jp-imersian-inhome')) customElements.define('jp-imersian-inhome', JpImersianInhome);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-not-found"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('.jp-not-found__trigger');
    if (!trigger) return;
    const discovery = trigger.closest('.jp-not-found__discovery');
    if (!discovery || discovery.hasAttribute('data-laid')) return;
    const rug = discovery.querySelector('.jp-not-found__secret');
    const message = discovery.querySelector('.jp-not-found__rug-message');
    if (!rug || !message) return;
    discovery.setAttribute('data-laid', '');
    trigger.disabled = true;
    trigger.setAttribute('aria-expanded', 'true');
    rug.hidden = false;
    rug.focus({ preventScroll: true });
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (motion.matches) {
      trigger.hidden = true;
      return;
    }
    const hideTrigger = window.setTimeout(() => { trigger.hidden = true; }, 850);
    const animations = [
      rug.animate(
        [{ transform: 'scaleY(.12)', opacity: 0 }, { transform: 'scaleY(1)', opacity: 1 }],
        { duration: 1400, easing: 'cubic-bezier(.25, .1, .25, 1)', fill: 'both' }
      ),
      message.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 900, delay: 500, easing: 'ease', fill: 'both' })
    ];
    const finishForReducedMotion = () => {
      if (!motion.matches) return;
      window.clearTimeout(hideTrigger);
      trigger.hidden = true;
      animations.forEach((animation) => animation.finish());
    };
    const cleanup = () => motion.removeEventListener('change', finishForReducedMotion);
    motion.addEventListener('change', finishForReducedMotion);
    Promise.allSettled(animations.map((animation) => animation.finished)).then(cleanup);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-product-reviews"]) return;
  try {
    
  class JPProductReviews extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { capture: true, signal: this.listeners.signal };
      document.addEventListener('click', this.activate, options);
      document.addEventListener('keydown', this.activate, options);
    }

    disconnectedCallback() {
      this.listeners?.abort();
    }

    activate = (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('.product-details .jdgm-preview-badge')) return;
      if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
      if (!this.querySelector('#judgeme_product_reviews')) return;
      if (!this.getClientRects().length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.scrollIntoView({ block: 'start', behavior: 'instant' });
      this.focus({ preventScroll: true });
    };
  }

  if (!customElements.get('jp-product-reviews')) {
    customElements.define('jp-product-reviews', JPProductReviews);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-product-use-cases"] && !Shopify.designMode) return;
  try {
    
  class JPProductUseCases extends HTMLElement {
    connectedCallback() {
      this.brandObserver?.disconnect();
      const removeBrand = () => this.querySelectorAll('a.snptwdgt__ftr-tgln12').forEach(brand => brand.remove());
      this.brandObserver = new MutationObserver(removeBrand);
      this.brandObserver.observe(this, { childList: true, subtree: true });
      removeBrand();
    }

    disconnectedCallback() {
      this.brandObserver?.disconnect();
    }
  }
  if (!customElements.get('jp-product-use-cases')) customElements.define('jp-product-use-cases', JPProductUseCases);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-rooms-scene"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const markers = () => document.querySelectorAll('.jp-rooms [data-styling-marker].is-active');
    const fit = (marker) => {
      const card = marker.querySelector('[data-styling-card]');
      const pin = marker.querySelector('[data-styling-pin]');
      const area = marker.closest('.jp-rooms__hotspot-area');
      if (!card || !pin || !area) return;
      card.style.setProperty('--jp-card-shift', '0px');
      card.style.setProperty('--jp-card-shift-y', '0px');
      const bounds = area.getBoundingClientRect();
      const rect = card.getBoundingClientRect();
      const anchor = pin.getBoundingClientRect();
      const left = Math.max(8, bounds.left + 8);
      const right = Math.min(document.documentElement.clientWidth - 8, bounds.right - 8);
      const top = bounds.top + 8;
      const bottom = bounds.bottom - 8;
      const clampX = (x) => Math.max(left, Math.min(x, right - rect.width));
      const centeredX = clampX(anchor.left + (anchor.width - rect.width) / 2);
      const centeredY = anchor.top + (anchor.height - rect.height) / 2;
      const candidates = [
        { x: clampX(rect.left), y: rect.top },
        { x: anchor.right + 14, y: centeredY },
        { x: anchor.left - 14 - rect.width, y: centeredY },
        { x: centeredX, y: anchor.top - 14 - rect.height },
        { x: centeredX, y: anchor.bottom + 14 },
      ];
      const avoidsPin = ({ x, y }) => x + rect.width <= anchor.left || x >= anchor.right
        || y + rect.height <= anchor.top || y >= anchor.bottom;
      const fits = ({ x, y }) => x >= left - 0.5 && x + rect.width <= right + 0.5
        && y >= top - 0.5 && y + rect.height <= bottom + 0.5;
      const position = candidates.find((candidate) => avoidsPin(candidate) && fits(candidate))
        || (anchor.top - top >= bottom - anchor.bottom ? candidates[3] : candidates[4]);
      card.style.setProperty('--jp-card-shift', `${position.x - rect.left}px`);
      card.style.setProperty('--jp-card-shift-y', `${position.y - rect.top}px`);
    };
    const close = (marker) => {
      const card = marker.querySelector('[data-styling-card]');
      if (card?.contains(document.activeElement)) marker.querySelector('[data-styling-pin]')?.focus();
      marker.classList.remove('is-active');
      marker.querySelector('[data-styling-pin]')?.setAttribute('aria-expanded', 'false');
    };
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const pin = event.target.closest('.jp-rooms [data-styling-pin]');
      if (event.target.closest('.jp-rooms [data-styling-card]')) return;
      for (const marker of markers()) {
        if (!pin || !marker.contains(pin)) close(marker);
      }
      if (pin) {
        const marker = pin.closest('[data-styling-marker]');
        const open = !marker.classList.contains('is-active');
        marker.classList.toggle('is-active', open);
        pin.setAttribute('aria-expanded', String(open));
        if (open) fit(marker);
      }
    });
    window.addEventListener('resize', () => { for (const marker of markers()) fit(marker); });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      for (const marker of markers()) close(marker);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jp-shop-feedback"] && !Shopify.designMode) return;
  try {
    
  class JPShopFeedback extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      const source = this.querySelector('[data-feedback-source]');
      if (!source) return;
      this.reviews = Array.from(source.content.querySelectorAll('.jdgm-carousel-item')).map(item => {
        const body = item.querySelector('.jdgm-carousel-item__review-body');
        const text = node => {
          if (node.nodeType === Node.TEXT_NODE) return node.textContent;
          if (node.nodeName === 'BR') return '\n';
          const content = Array.from(node.childNodes).map(text).join('');
          return ['P', 'DIV'].includes(node.nodeName) ? content + '\n' : content;
        };
        const image = item.querySelector('img');
        const imageSource = image?.getAttribute('data-src-retina') || image?.getAttribute('data-src') || image?.getAttribute('src');
        const url = item.querySelector('.jdgm-carousel-item__product[href]')?.getAttribute('href');
        let link = '', imageURL = '';
        try {
          const resolved = new URL(url || '', location.origin);
          if (url && resolved.origin === location.origin && resolved.pathname.startsWith('/products/')) link = resolved.href;
        } catch {}
        try {
          const resolved = new URL(imageSource || '', location.origin);
          if (imageSource && ['http:', 'https:'].includes(resolved.protocol)) imageURL = resolved.href;
        } catch {}
        return {
          title: item.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim() || '',
          body: body ? text(body).trim() : '',
          product: item.querySelector('.jdgm-carousel-item__product-title')?.textContent.trim() || '',
          rating: Number((item.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label') || '').match(/[\d.]+/)?.[0] || 0),
          image: imageURL,
          link
        };
      });
      if (!this.reviews.length) { this.closest('.jp-shop-feedback').hidden = true; return; }
      this.controller = new AbortController();
      this.track = this.querySelector('[data-feedback-track]');
      this.dialog = this.querySelector('dialog');
      this.position = 0;
      this.interval = Number(this.dataset.interval) || 0;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.desktop = matchMedia('(min-width: 769px)');
      this.paused = this.reduced.matches;
      this.visible = false;
      this.moving = false;
      const on = (target, type, handler) => target.addEventListener(type, handler, { signal: this.controller.signal });
      on(this.querySelector('[data-feedback-prev]'), 'click', () => this.advance(-1));
      on(this.querySelector('[data-feedback-next]'), 'click', () => this.advance(1));
      on(this.querySelector('[data-feedback-toggle]'), 'click', () => { this.paused = !this.paused; this.syncToggle(); });
      on(this.track, 'click', event => {
        const button = event.target.closest('[data-review]');
        if (!button) return;
        const review = this.reviews[Number(button.dataset.review)];
        clearTimeout(this.timer);
        this.querySelector('[data-full-title]').textContent = review.title || review.product;
        this.querySelector('[data-full-body]').textContent = review.body;
        this.querySelector('[data-full-product]').textContent = review.product;
        this.querySelector('[data-full-rating]').replaceChildren(this.rating(review.rating));
        this.returnFocus = button;
        this.dialog.showModal();
      });
      on(this.dialog.querySelector('.dialog-close'), 'click', () => this.dialog.close());
      on(this.dialog, 'close', () => {
        const target = this.returnFocus?.isConnected && !this.returnFocus.hidden ? this.returnFocus : this.querySelector('[data-feedback-next]');
        target?.focus({ preventScroll: true });
        this.schedule();
      });
      on(document, 'visibilitychange', () => this.schedule());
      on(this.desktop, 'change', () => { if (!this.moving) this.render(); });
      on(this.reduced, 'change', event => { if (event.matches) { this.paused = true; this.syncToggle(); } });
      on(this, 'focusin', event => { if (this.track.contains(event.target)) clearTimeout(this.timer); });
      on(this, 'focusout', event => { if (!this.track.contains(event.relatedTarget)) this.schedule(); });
      this.hidden = false;
      this.render();
      this.syncToggle();
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.1 });
      this.visibilityObserver.observe(this);
      this.resizeObserver = new ResizeObserver(() => this.checkOverflow());
      this.resizeObserver.observe(this.track);
      document.fonts.ready.then(() => { if (this.isConnected) this.checkOverflow(); });
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.animation?.cancel();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.dialog?.close();
      this.controller?.abort();
      this.controller = null;
    }

    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }

    rating(value) {
      const count = Math.max(0, Math.min(5, Math.round(value)));
      const stars = this.element('span', 'stars', '★'.repeat(count));
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `5点満点中${count}点`);
      stars.append(this.element('span', 'empty', '★'.repeat(5 - count)));
      return stars;
    }

    wrap(index) { return (index + this.reviews.length) % this.reviews.length; }

    card(index, offset) {
      const review = this.reviews[index];
      const card = this.element('article', 'card');
      if (offset >= (this.desktop.matches ? Math.min(3, this.reviews.length) : 1)) { card.inert = true; card.setAttribute('aria-hidden', 'true'); }
      card.append(this.rating(review.rating), this.element('h3', 'review-title', review.title || review.product), this.element('p', 'review-body', review.body));
      const slot = this.element('div', 'read-slot');
      const more = this.element('button', 'read-more', '続きを読む');
      more.type = 'button';
      more.dataset.review = index;
      more.hidden = true;
      more.setAttribute('aria-haspopup', 'dialog');
      slot.append(more);
      card.append(slot);
      const product = this.element(review.link ? 'a' : 'div', 'product');
      if (review.link) product.href = review.link;
      const photo = this.element('span', 'photo');
      if (review.image) {
        const image = this.element('img');
        image.alt = review.product;
        image.width = 48;
        image.height = 48;
        image.addEventListener('error', () => { photo.textContent = '商品画像'; }, { once: true });
        image.src = review.image;
        photo.append(image);
      } else photo.textContent = '商品画像';
      product.append(photo, this.element('span', 'product-name', review.product));
      card.append(product);
      return card;
    }

    render() {
      const visibleCount = this.desktop.matches ? Math.min(3, this.reviews.length) : 1;
      this.style.setProperty('--visible-count', visibleCount);
      this.track.replaceChildren(...Array.from({ length: this.reviews.length > 1 ? visibleCount + 1 : 1 }, (_, offset) => this.card(this.wrap(this.position + offset), offset)));
      this.querySelector('[data-feedback-count]').textContent = `${String(this.position + 1).padStart(2, '0')} / ${String(this.reviews.length).padStart(2, '0')}`;
      const progress = this.querySelector('[data-feedback-progress]');
      progress.style.width = 100 / this.reviews.length + '%';
      progress.style.transform = `translateX(${this.position * 100}%)`;
      this.checkOverflow();
      this.querySelector('[data-feedback-prev]').disabled = this.reviews.length < 2;
      this.querySelector('[data-feedback-next]').disabled = this.reviews.length < 2;
    }

    checkOverflow() {
      this.track?.querySelectorAll('.card').forEach(card => {
        const body = card.querySelector('.review-body'), title = card.querySelector('.review-title');
        card.querySelector('.read-more').hidden = !(body.scrollHeight > body.clientHeight + 1 || title.scrollHeight > title.clientHeight + 1);
      });
    }

    syncToggle() {
      const toggle = this.querySelector('[data-feedback-toggle]');
      toggle.hidden = !this.interval || this.reviews.length < 2;
      toggle.textContent = this.paused ? '▶' : 'Ⅱ';
      toggle.setAttribute('aria-label', this.paused ? '自動送りを再開' : '自動送りを停止');
      toggle.setAttribute('aria-pressed', String(this.paused));
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (this.isConnected && this.interval && this.reviews.length > 1 && !this.paused && this.visible && !document.hidden && !this.dialog.open && !this.track.contains(document.activeElement)) {
        this.timer = setTimeout(() => this.advance(1), this.interval);
      }
    }

    async advance(direction) {
      if (this.moving || this.dialog.open || this.reviews.length < 2) return;
      clearTimeout(this.timer);
      this.moving = true;
      const next = this.wrap(this.position + direction);
      if (direction < 0) { this.position = next; this.render(); }
      const step = this.track.querySelector('.card').getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
      const animation = this.track.animate([
        { transform: `translateX(${direction > 0 ? 0 : -step}px)` },
        { transform: `translateX(${direction > 0 ? -step : 0}px)` }
      ], { duration: this.reduced.matches ? 0 : 360, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'forwards' });
      this.animation = animation;
      try {
        await animation.finished;
        if (this.isConnected) { this.position = next; this.render(); }
      } catch {} finally {
        animation.cancel();
        if (this.animation === animation) this.animation = null;
        this.moving = false;
        if (this.isConnected) this.schedule();
      }
    }
  }
  if (!customElements.get('jp-shop-feedback')) customElements.define('jp-shop-feedback', JPShopFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  let jpCartReloadPending = false;
  document.addEventListener('cart:update', (event) => {
    if (document.querySelector('[data-jp-delivery-adapter]')) return;
    if (jpCartReloadPending || event.detail?.data?.source !== 'cart-items-component') return;
    const cart = event.target?.closest?.('cart-items-component:not([data-drawer])');
    if (!cart?.querySelector('.cart-page__more-blocks .shopify-app-block')) return;
    jpCartReloadPending = true;
    queueMicrotask(() => window.location.reload());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.gl-filters-toggle');
    if (!button) return;

    const wrapper = button.closest('.collection-wrapper--gl-filters');
    if (!wrapper) return;

    const isOpen = wrapper.classList.toggle('gl-filters-open');
    button.setAttribute('aria-expanded', String(isOpen));
    button.querySelector('.gl-filters-toggle__symbol').textContent = isOpen ? '−' : '+';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  const productCache = new Map();
  const STORAGE_KEY_HANDLES = 'viewedProductHandles';
  const TRIAL_HANDLES = new Set(['qa-bono-stock', 'qa-bono-fixed-custom-size']);
  
  function getStoredHandles() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY_HANDLES) || '[]');
      if (!Array.isArray(parsed)) return [];
      const filtered = parsed.filter((handle) => typeof handle === 'string' && !TRIAL_HANDLES.has(handle));
      localStorage.setItem(STORAGE_KEY_HANDLES, JSON.stringify(filtered));
      return filtered;
    } catch {
      return [];
    }
  }
  
  class RecentlyViewedProductsSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      const run = () => this.loadProducts();
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(run, { timeout: 500 });
      } else {
        window.setTimeout(run, 0);
      }
    }
  
    async loadProducts() {
      const currentHandle = this.dataset.currentHandle || '';
      const sectionLimit = Number.parseInt(this.dataset.maxProducts || '4', 10) || 4;
      const currency = this.dataset.currency || 'USD';
  
      const viewedHandles = getStoredHandles()
        .filter((handle) => typeof handle === 'string' && handle.length > 0)
        .filter((handle) => handle !== currentHandle)
        .slice(0, sectionLimit);
  
      if (viewedHandles.length === 0) {
        this.hidden = true;
        return;
      }
  
      const products = await this.fetchProducts(viewedHandles);
      const validProducts = products.filter(Boolean).slice(0, sectionLimit);
  
      if (validProducts.length === 0) {
        this.hidden = true;
        return;
      }
  
      const grid = this.querySelector('[ref="recentlyViewedGrid"]');
      if (!(grid instanceof HTMLElement)) {
        this.hidden = true;
        return;
      }
  
      grid.innerHTML = '';
      validProducts.forEach((product) => {
        grid.append(this.renderCard(product, currency));
      });
  
      this.hidden = false;
    }
  
    async fetchProducts(handles) {
      const root = window.Shopify?.routes?.root || '/';
      const previewParams = new URLSearchParams(window.location.search);
  
      const requests = handles.map(async (handle) => {
        if (productCache.has(handle)) return productCache.get(handle);
  
        const url = new URL(`${root}products/${encodeURIComponent(handle)}`, window.location.origin);
        url.searchParams.set('view', 'recently-viewed');
        previewParams.forEach((value, key) => {
          if (!url.searchParams.has(key)) {
            url.searchParams.set(key, value);
          }
        });
  
        try {
          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) return null;
          const data = await response.json();
          productCache.set(handle, data);
          return data;
        } catch {
          return null;
        }
      });
  
      return Promise.all(requests);
    }
  
    renderCard(product, currency) {
      const item = document.createElement('li');
      item.className = 'recently-viewed-products__item';
  
      const link = document.createElement('a');
      link.className = 'recently-viewed-products__card-link';
      link.href = product.url || `/products/${product.handle}`;
  
      const imageWrap = document.createElement('div');
      imageWrap.className = 'recently-viewed-products__image-wrap';
  
      if (Array.isArray(product.images) && product.images[0]) {
        const img = document.createElement('img');
        img.className = 'recently-viewed-products__image';
        img.src = product.images[0];
        img.alt = product.title || '';
        img.loading = 'lazy';
        imageWrap.append(img);
      }
  
      const name = document.createElement('p');
      name.className = 'recently-viewed-products__name';
      name.textContent = product.title || '';
  
      const price = document.createElement('div');
      price.className = 'recently-viewed-products__price';
      if (product.price_html) {
        price.innerHTML = product.price_html;
      } else {
        price.textContent = this.formatMoney(product.price, currency);
      }
  
      link.append(imageWrap, name, price);
      item.append(link);
  
      return item;
    }
  
    formatMoney(cents, currency) {
      const value = Number(cents || 0) / 100;
  
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency,
          maximumFractionDigits: 2,
        }).format(value);
      } catch {
        return `$${value.toFixed(2)}`;
      }
    }
  }
  
  if (!customElements.get('recently-viewed-products-section')) {
    customElements.define('recently-viewed-products-section', RecentlyViewedProductsSection);
  }

  } catch(e) { console.error(e); }
})();
})();
